import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-50">
                88影视网
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              88影视网提供高清影视在线观看资源，涵盖高清电影电视剧、超清影视播放等内容，高清不卡顿，畅享极致观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  高清电影
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  电视剧
                </Link>
              </li>
              <li>
                <Link to="/category/anime" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  动漫
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/variety" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  热门综艺
                </Link>
              </li>
              <li>
                <Link to="/category/documentary" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  纪录片
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  最新电影
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  热播剧集
                </Link>
              </li>
              <li>
                <Link to="/category/anime" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  国产动漫
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-mail-line text-base text-primary-500"></i>
                <span>contact@88yingshi.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-phone-line text-base text-primary-500"></i>
                <span>400-888-8888</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-map-pin-line text-base text-primary-500"></i>
                <span>北京市朝阳区影视产业园A座</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="#wechat"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-background-300 transition-all duration-200 cursor-pointer"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a
                href="#weibo"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-background-300 transition-all duration-200 cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 88影视网 - 高清影视在线观看 | 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors duration-200">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors duration-200">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors duration-200">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}